/**
 * Recall Management Routes
 */
import type { RouteRecordRaw } from 'vue-router';

export const recallRoutes: RouteRecordRaw[] = [
  {
    path: '/recall',
    name: 'recall',
    component: () => import('./views/RecallListView.vue'),
    meta: {
      title: 'Recall Management',
      breadcrumbs: [{ label: 'Recall Management' }],
      modulePermission: 'recall',
    },
  },
];
